
import React from 'react';
import { AppProvider, useApp } from './store';
import { Layout } from './components/Layout';
import RoleSpecificDashboard from './pages/Dashboard';
import Login from './pages/Login';

const AppContent: React.FC = () => {
  const { isAuthenticated, isLoading } = useApp();

  if (isLoading && !isAuthenticated) {
    return (
      <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center">
        <div className="w-10 h-10 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest animate-pulse">Initializing System...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Layout>
      <RoleSpecificDashboard />
    </Layout>
  );
};

const App: React.FC = () => {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
};

export default App;
